import { Space, Typography } from "antd";
import { apiHost } from "consts";
import bem from "easy-bem";
import CardSample from "features/cases/blocks/CommonCard";
import { useDataQueryRefetch } from "hooks/useData";
import { useIsMobile } from "hooks/useIsMobile";
import { useTexts } from "hooks/useTexts";
import { useUser } from "hooks/useUser";
import React from "react";

import "./CaseSolutions.css";

const cn = bem("case-solutions");

type CaseSolutionsProps = {
  problemId: string;
  solutionId: string;
  solutionList: any[];
};

const CaseSolutions: React.FC<CaseSolutionsProps> = ({
  problemId,
  solutionId,
  solutionList,
}) => {
  const { isMobile } = useIsMobile();
  const { txt } = useTexts("case");
  const { isContributor, isBannedFromPublishing } = useUser();

  const canAddSolution = isContributor && !isBannedFromPublishing;

  const { data: generalData, refetch: refetchGeneral } =
    useDataQueryRefetch("general");
  const nextSolutionId = generalData?.nextSolutionId;
  const editorAddUrl = nextSolutionId
    ? `#/problems/${problemId}/solutions/add`
    : "#";

  if (!solutionList?.length && !isContributor) return null;

  if (!solutionList?.length) {
    return (
      <div className={cn({ mobile: isMobile })}>
        <Typography.Title
          level={4}
          className={cn("title")}
        >
          {txt("add_solution", "Добавить решение")}
        </Typography.Title>

        {canAddSolution && (
          <div
            onClick={(e) => {
              window.location.href = editorAddUrl;
              e.stopPropagation();
              refetchGeneral();
            }}
          >
            <CardSample
              parentData={{
                isProblem: false,
                isSolution: true,
                isAttribute: false,
                problemId,
                solutionId,
              }}
              key="new"
              addUrl={editorAddUrl}
            />
          </div>
        )}
      </div>
    );
  }

  if (!(solutionList.length > (solutionId ? 1 : 0) || isContributor))
    return null;

  return (
    <div
      id={!solutionId ? "secondcard" : ""}
      className={cn({ mobile: isMobile })}
    >
      <Typography.Title
        level={4}
        className={cn("title")}
      >
        {solutionId
          ? txt("other_solutions", "Другие решения")
          : txt("solutions", "Решения")}
      </Typography.Title>

      <Space
        direction="horizontal"
        align="start"
        size="middle"
        wrap
        style={{ display: "flex", padding: 0, alignItems: "stretch" }}
        className={cn("cards")}
      >
        {/*@ts-ignore*/}
        {solutionList
          .filter((solution: any) => solution.id != solutionId)
          .map((solution: any) => (
            <CardSample
              parentData={{
                isProblem: false,
                isSolution: true,
                isAttribute: false,
                problemId,
                solutionId: solution?.id,
              }}
              cardContentId={solution?.id}
              sectionTitle={txt("solution", "Решение")}
              objectColor="#B7EAFF"
              highlightColor="#22AAE0"
              key={"top" + solution?.id}
              mode="default"
              meta={solution?.meta}
              title={solution?.title}
              description={solution?.description}
              url={`#/problems/${problemId}/solutions/${solution?.id}/`}
              editUrl={`${apiHost}/admin/solutions/solution/${solution?.id}/change/`}
              linkButtonText={
                isContributor
                  ? txt("more_details", "Подробнее")
                  : txt("more_details_solution", "Подробнее о решении")
              }
            />
          ))}

        {canAddSolution && (
          <div
            onClick={(e) => {
              window.location.href = editorAddUrl;
              e.stopPropagation();
            }}
          >
            <CardSample
              parentData={{
                isProblem: false,
                isSolution: true,
                isAttribute: false,
                problemId,
                solutionId,
              }}
              key="new"
              addUrl={editorAddUrl}
            />
          </div>
        )}
      </Space>
    </div>
  );
};

export default CaseSolutions;
